import "normalize.css/normalize.css";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fontsource/inter";
import { mount } from "svelte";
import { initializeI18n } from "../common/service/i18n/index.ts";
import App from "./App.svelte";

initializeI18n();

const target = document.getElementById("app");
if (!target) {
	throw new Error("root element #app not found");
}

const app = mount(App, { target });
export default app;
